(function () {
  var carousels = document.querySelectorAll('.beaglex-kit__steps');
  carousels.forEach(function (track) {
    var wrap = track.closest('.beaglex-kit__inner');
    if (!wrap) return;
    var dots = wrap.querySelectorAll('[data-kit-dot]');
    var steps = track.querySelectorAll('[data-kit-step]');
    if (!dots.length || !steps.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-kit-dot'), 10);
        var target = steps[index];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = Array.prototype.indexOf.call(steps, entry.target);
              if (index > -1) setActive(index);
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      steps.forEach(function (step) {
        observer.observe(step);
      });
    }
  });
})();
